import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d8e235b4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.less?vue&type=style&index=0&id=d8e235b4&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e235b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/b08365e4-b55a-4269-82b4-b5e5a1490008/workspace/hsylc_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8e235b4')) {
      api.createRecord('d8e235b4', component.options)
    } else {
      api.reload('d8e235b4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d8e235b4&scoped=true", function () {
      api.rerender('d8e235b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OnlineNoticeDialog/index.vue"
export default component.exports